import shortid from "shortid"

function TicketItem({ item }) {

  const fixString = (s) => {
    let convert1 = s.split(",")

    let convert2 = convert1.map(item => {
      return item.split("")
    })

    let convert3 = convert2.map(item => {
      let filtered = item.filter(value => value !== '"')
      filtered = filtered.filter(value => value !== '[')
      filtered = filtered.filter(value => value !== ']')
      filtered = filtered.join("")

      return filtered
    })
    
    return convert3
  }

  let toppings = fixString(item.toppings)
  let extras = fixString(item.extras)
  let additions = fixString(item.additions)
  let spreads = fixString(item.spreads)
  let sauces = fixString(item.sauces)
  let dressings = fixString(item.dressings)

  return (
    <div className="ticket-item">
      <div className="ti-snqsu">
        <span>({item.servings})</span>

        <span className="ti-name">{item.name}</span>

        {!item.quantity && !item.size && !item.unitList && !item.unit ?
          null :
          <>
            {item.quantity ?
              <span className="ti-quan">
                ({item.quantity}
              </span>
            : <span>(</span>}

            <span>{item.size}</span>

            {item.unit_list ? 
              item.name !== "Garlic Knots" ?
                <span className="ti-unit_list">
                  {item.unit_list} )
                </span> :
                <span className="ti-unit_list">3 Pcs. )</span>
            : <span>)</span>}
          </>
        }
      </div>
      
      <span className="ti-detail">{item.detail}</span>

      <div className="ti-teassd">
        {spreads.length === 1 && spreads[0] === "" ?
          null :
          spreads.map(item => {
            if (item !== "") {
              return <span className="ti-spreads" key={shortid.generate()}>- {item}</span>
            } else {
              return null
            }
          })
        }

        {toppings.length === 1 && toppings[0] === "" ?
          null :
          toppings.map(item => {
            if (item !== "") {
              return <span className="ti-toppings" key={shortid.generate()}>- {item}</span>
            } else {
              return null
            }
          })
        }

        {extras.length === 1 && extras[0] === "" ?
          null :
          extras.map(item => {
            if (item !== "") {
              return <span className="ti-extras" key={shortid.generate()}>- {item}</span>
            } else {
              return null
            }
          })
        }
        
        {additions.length === 1 && additions[0] === "" ?
          null :
          additions.map(item => {
            if (item !== "") {
              return <span className="ti-additions" key={shortid.generate()}>- ADD {item}</span>
            } else {
              return null
            }
          })
        }

        {sauces.length === 1 && sauces[0] === "" ?
          null :
          sauces.map(item => {
            if (item !== "") {
              return <span className="ti-sauces" key={shortid.generate()}>- SIDE: {item}</span>
            } else {
              return null
            }
          })
        }
        
        {dressings.length === 1 && dressings[0] === "" ?
          null :
          dressings.map(item => {
            if (item !== "") {
              return <span className="ti-dressings" key={shortid.generate()}>- SIDE: {item}</span>
            } else {
              return null
            }
          })
        }
      </div>

    </div>
  )
}

export default TicketItem
